import * as AddBackorderDemandEvent from '@ori-events/add-backorder-demand';
import * as BasketUpdatedEvent from '@ori-events/basket-updated';
import * as ReplaceShoppingBagItem from '@ori-events/replace-shopping-bag-item';
import * as ReplaceSubscriptionEvent from '@ori-events/replace-subscription';
import { useCallback, useEffect, useState } from 'react';

export interface UseCloseEventsProps {
  onClose: () => void;
}

type CloseEvent =
  | AddBackorderDemandEvent.Event
  | ReplaceShoppingBagItem.Event
  | ReplaceSubscriptionEvent.Event;

const events = [
  AddBackorderDemandEvent.Name,
  ReplaceShoppingBagItem.Name,
  ReplaceSubscriptionEvent.Name,
] as const;

export const useCloseEvents = ({ onClose }: UseCloseEventsProps) => {
  const [closeEvent, setCloseEvent] = useState<CloseEvent>();
  const onBasketUpdated = useCallback(() => {
    if (closeEvent) {
      onClose();
      setCloseEvent(undefined);
    }
  }, [closeEvent, onClose]);
  useEffect(() => {
    events.forEach((event) => window.addEventListener(event, setCloseEvent));
    window.addEventListener(BasketUpdatedEvent.Name, onBasketUpdated);

    return () => {
      events.forEach((event) => window.removeEventListener(event, setCloseEvent));
      window.removeEventListener(BasketUpdatedEvent.Name, onBasketUpdated);
    };
  }, [onBasketUpdated, onClose]);
};
